import { format } from 'owa-localize';
import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import { makePostRequest } from 'owa-ows-gateway/lib/makeServiceRequest';
import { getGuid } from 'owa-guid';
import {
    GRIFFIN_REQUEST_BASEURL,
    GRIFFIN_REQUEST_UNBLOCK,
    USER_SETTINGS,
    UNBLOCK,
} from '../helpers/TxpConstants';
import getTxpSettingsSaveCustomData from './../utils/getTxpSettingsSaveCustomData';

import { logCalendarUsage } from 'owa-shared-analytics';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';

export default function postUserSettingsAction(
    body?: TxpGriffinSettingsPayload,
    entryPoint?: TxpSettingsEntryPoint,
    isSettingsChange?: boolean
): Promise<any> {
    let apiPath: string = UNBLOCK;
    let requestBody: any = {};
    let baseUrl: string = GRIFFIN_REQUEST_UNBLOCK;

    if (isSettingsChange) {
        apiPath = USER_SETTINGS;
        requestBody = body;
        baseUrl = GRIFFIN_REQUEST_BASEURL;
        logCalendarUsage('TxpSettingsSave', getTxpSettingsSaveCustomData(body, entryPoint));
    }

    return makePostRequest(
        format(baseUrl, apiPath),
        requestBody,
        getGuid(),
        true /*returnFullResponse*/,
        null /*customHeaders*/,
        null /*throwServiceError*/,
        true /*sendPayloadAsBody*/
    );
}
